module.exports = __webpack_public_path__ + "static/media/menuicon.37965b02.svg";